<div class="ctm-tab custom-card card-accord">
  <div class="modal-header">
    
    <h4 class="modal-title" id="modal-basic-title" *ngIf="isFromEditAppointment" translate>
      lblSelectBillToCustomer
    </h4>
    <h4 class="modal-title" id="modal-basic-title" *ngIf="!isFromEditAppointment" translate>
      lblCustomerValidation
    </h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="OnClose()"
      aria-label="Center Align"
    >
      <span aria-hidden="true"> × </span>
    </button>
  </div>

  <div class="modal-body p-0">
    <div class="card pad15 pb-0">
      <ngb-accordion #a="ngbAccordion" [activeIds]="activePanel">
        <ngb-panel id="first" *ngIf="customer">
          <ng-template ngbPanelHeader class="custom-header ctm">
            <div class="d-flex align-items-center drop-down-style">
              <button
                ngbPanelToggle
                translate
                class="btn d-flex w-100 align-items-center font16 font-weight"
                aria-label="Center Align"
              >
                lblCustomerInformation
                <span class="font16 ml-4">(</span>
                <span class="font16" translate>{{ isWidgetData }}</span>
                <span class="font16">)</span>
                <ng-container *ngIf="!a.activeIds.includes('first')"
                  ><em class="fas fa-angle-down fa-lg ml-auto"></em>
                </ng-container>
                <ng-container *ngIf="a.activeIds.includes('first')"
                  ><em class="fas fa-angle-up fa-lg ml-auto"></em>
                </ng-container>
              </button>
            </div>
          </ng-template>
          <ng-template ngbPanelContent>
            <div class="row" *ngIf="customer">
              <div class="col-6">
                <div class="row">
                  <div class="col-6">
                    <div class="af-form-group">
                      <label translate>lblCustomer</label>
                      <div class="d-flex align-items-center" *ngIf="customer.customerName; else load_name">
                        <div class="lbl-info">
                          {{ customer.customerName }}
                        </div>
                        <button
                          class="btn btn-link ml-2"
                          (click)="copyText(customer.customerName)"
                          placement="top"
                          ngbTooltip="{{'lblCopy' | translate}}"
                          aria-label="Center Align"
                        >
                          <em class="fas fa-copy fa-lg"></em>
                        </button>
                      </div>
                      <ng-template #load_name>
                        <div class="lbl-info">
                          -
                        </div>
                      </ng-template>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="af-form-group">
                      <label translate>lblMobileNo</label>
                      <div class="d-flex align-items-center" *ngIf="customer.mobileNo; else load_mobileNo">
                        <div class="lbl-info">
                          {{ customer.cust_ContactNo.internationalNumber }}
                        </div>
                        <button
                          class="btn btn-link ml-2"
                          (click)="copyText(customer.mobileNo)"
                          placement="top"
                          ngbTooltip="{{'lblCopy' | translate}}"
                          aria-label="Center Align"
                        >
                          <em class="fas fa-copy fa-lg"></em>
                        </button>
                      </div>
                      <ng-template #load_mobileNo>
                        <div class="lbl-info">
                          -
                        </div>
                      </ng-template>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="af-form-group">
                      <label translate>lblAddressLine2</label>
                      <div class="lbl-info" *ngIf="customer.address2; else load_address2">
                        {{ customer.address2 }}
                      </div>
                      <ng-template #load_address2>
                        <div class="lbl-info">
                          -
                        </div>
                      </ng-template>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="af-form-group">
                      <label translate>lblCity</label>
                      <div class="lbl-info" *ngIf="customer.city; else load_city">{{ customer.city }}</div>
                      <ng-template #load_city>
                        <div class="lbl-info">
                          -
                        </div>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="row">
                  <div class="col-6">
                    <div class="af-form-group">
                      <label translate>lblEmail</label>
                      <div class="d-flex align-items-center" *ngIf="customer.email; else load_email">
                        <div class="lbl-info">{{ customer.email }}</div>
                        <button
                          class="btn btn-link ml-2"
                          (click)="copyText(customer.email)"
                          placement="top"
                          ngbTooltip="{{'lblCopy' | translate}}"
                          aria-label="Center Align"
                        >
                          <em class="fas fa-copy fa-lg"></em>
                        </button>
                      </div>
                      <ng-template #load_email>
                        <div class="lbl-info">
                          -
                        </div>
                      </ng-template>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="af-form-group" >
                      <label translate>lblAddressLine1</label>
                      <div class="lbl-info" *ngIf="customer.address1; else load_address1">{{ customer.address1 }}</div>
                      <ng-template #load_address1>
                        <div class="lbl-info">
                          -
                        </div>
                      </ng-template>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="af-form-group" >
                      <label translate>lblCountry</label>
                      <div class="lbl-info" *ngIf="customer.country; else load_country">{{ customer.country }}</div>
                      <ng-template #load_country>
                        <div class="lbl-info">
                          -
                        </div>
                      </ng-template>
                    </div>

                  </div>
                  <div class="col-6">
                    <div class="af-form-group" >
                      <label translate>lblPostcode</label>
                      <div class="lbl-info" *ngIf="customer.postCode; else load_postCode">{{ customer.postCode }}</div>
                      <ng-template #load_postCode>
                        <div class="lbl-info">
                          -
                        </div>
                      </ng-template>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </ngb-panel>

        <ngb-panel id="second">
          <ng-template ngbPanelHeader class="custom-header ctm">
            <div class="d-flex align-items-center drop-down-style">
              <button
                ngbPanelToggle
                translate
                class="btn d-flex w-100 align-items-center text-left font16 font-weight"
                aria-label="Center Align"
              >
                Search Customer
                <ng-container *ngIf="!a.activeIds.includes('second')"
                  ><em class="fas fa-angle-down fa-lg ml-auto"></em>
                </ng-container>
                <ng-container *ngIf="a.activeIds.includes('second')"
                  ><em class="fas fa-angle-up fa-lg ml-auto"></em>
                </ng-container>
              </button>
            </div>
          </ng-template>
          <ng-template ngbPanelContent>
            <div class="col-3 col-lg-3 pl-0 mb-3">
              <div class="d-flex">
                <div class="flex-grow-1">
                  <div class="input-group">
                    <input
                      class="form-control"
                      type="text"
                      name="searchTerm"
                      placeholder="{{ 'lblSearch' | translate }}"
                      [(ngModel)]="searchTerm"
                      autocomplete="off"
                      (keyup.enter)="onSearchFilter()"
                    />
                    <div class="input-group-append">
                      <button type="button" class="btn btn-primary" (click)="onSearchFilter()">
                        <em class="fa fa-search"></em>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="table-responsive tableMx-15">
            <table mdbTable class="tablest1">
              <thead>
                <tr>
                  <th style="width: 60px" scope="col" class="text-center" translate>lblSelect</th>
                  <th style="width: 15%" scope="col" translate>lblCustomerNumber</th>
                  <th style="width: 15%" scope="col" translate>lblIsActive</th>
                  <th style="width: 27%" scope="col" translate>lblCustomer</th>
                  <th  scope="col" translate>lblAddress</th>
                  <th style="width: 11%" scope="col" translate>lblCountry</th>
                  <th style="width: 15%" scope="col" translate>lblCustomerType</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="customerList?.length > 0; else load_else">
                  <ng-container
                    *ngFor="let cust of customerList; let i = index"
                  >
                    <tr [ngClass]="{'clrRed' : !cust.isActive}">
                      <td class="text-center" >
                        <input
                          name="select"
                          type="radio"
                          class="radio-custom"
                          [value]="cust.isSelected"
                          (change)="onCustomerSelect(i,$event)"
                         
                        />
                      </td>
                      <td>
                        <ngb-highlight [result]="cust.customerNo">
                        </ngb-highlight>
                      </td>
                      <td>
                        <!-- {{cust.isActive}} -->
                        <ng-container *ngIf="cust.isActive; else load_else_isActive">
                          <em class="fas fa-check"></em>
                        </ng-container>
                        <ng-template #load_else_isActive>
                          <em class="fas fa-times text-danger cursordisable"></em>
                        </ng-template>
                      </td>
                      <td>
                        <ngb-highlight class="fs-14px semibold lh-18px d-block" [result]="cust.customerName"
                          >{{ cust.customerName }}
                        </ngb-highlight>
                        <div class="d-flex align-items-center mt-1 fs-12px lh-16px"  *ngIf="cust.mobileNo">
                          <em class="fas fa-phone-flip fs-10px fa-lg mr-2 clr666"></em>
                          <span class="fs-12px" >{{ cust.mobileCode }} -</span>
                          <ngb-highlight class="fs-12px" [result]="cust.mobileNo"
                          >{{ cust.mobileNo }}
                          </ngb-highlight>
                        </div>
                        <div class="d-flex align-items-center" *ngIf="cust.email">
                          <em class="fas fa-envelope fs-10px fa-lg mr-2 clr666"></em>
                          <ngb-highlight class="fs-12px" [result]="cust.email">
                          </ngb-highlight>
                        </div>

                      </td>
                      <td>
                        <ngb-highlight [result]="cust.address"
                          >{{ cust.address }}
                        </ngb-highlight>
                        <div class="d-flex align-items-center mt-1 fs-12px lh-16px">
                            <ngb-highlight class="fs-12px mr-2" [result]="cust.pincode">
                            </ngb-highlight>
                            <ngb-highlight class="fs-12px" [result]="cust.city">
                            </ngb-highlight>
                        </div>
                      <td>
                        <ngb-highlight [result]="cust.country">
                          {{ cust.country }}
                        </ngb-highlight>
                      </td>
                      <td>
                          <ngb-highlight [result]="cust.customerType"
                          >{{ cust.customerType }}
                        </ngb-highlight>
                      </td>
                    </tr>
                  </ng-container>
                </ng-container>
                <ng-template #load_else>
                  <tr>
                    <td colspan="12" class="no-record" translate>
                      lblNoRecordsFound
                    </td>
                  </tr>
                </ng-template>
              </tbody>
            </table>
          </div>
            <div class="card-footer tableMx-15">
              <div class="d-flex justify-content-between">
                <app-pagination
                  [pager]="pager"
                  [recordSize]="totalCount"
                  (setPageEvent)="setPage($event)"
                >
                </app-pagination>
                <div
                  class="d-flex align-items-center justify-content-between font17 fontbold"
                >
                  <span class="font17 fontnormal" translate>lblTotal</span
                  >:&nbsp;{{ totalCount }}&nbsp;<span
                    class="font17 fontnormal"
                    translate
                    >lblResults</span
                  >
                </div>
              </div>
            </div>
          </ng-template>
        </ngb-panel>
      </ngb-accordion>
    </div>




  </div>


  <div class="p-3 bg-light">
    <div class="d-flex flex-sm-row flex-column justify-content-end">
      <button
        class="btn btn-primary mr-sm-2 "
        (click)="onSelect()"
        translate
        [disabled]="!isSelectActive"
        aria-label="Center Align"
      >
        lblSelect
      </button>
      <button
        class="btn btn-primary mr-sm-2 "
        (click)="onCreate()"
        translate
        aria-label="Center Align"
        *ngIf="!isFromEditAppointment" 
      >
        lblCreate
      </button>
      <a
        (click)="OnClose()"
        type="reset"
        class="btn btn-secondary "
        translate
        >lblCancel</a
      >
    </div>
  </div>
</div>
